import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6535626a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-block" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "map-block__card"
}
const _hoisted_4 = {
  key: 1,
  class: "map-block__card"
}

import { LoadingOfferCard, OfferSmallCard } from '@/components/Cards';
import { Ref, ref, shallowRef } from 'vue';
import type { LngLat, YMap } from '@yandex/ymaps3-types';
import {
  YandexMap,
  YandexMapControls,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultSchemeLayer,
  YandexMapGeolocationControl,
  YandexMapMarker,
  YandexMapZoomControl,
} from 'vue-yandex-maps';
import { ResultCardType } from '@/types';
import { OfferCardCoordinatesType } from '@/api/house/types';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { goToCard } from '@/utils/Cards/OfferCard';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBlock',
  props: {
    resultCardsCoordinates: {},
    height: { default: '500' },
    centerPointMap: {},
    zoom: {},
    showOfferCard: { type: Boolean },
    isFull: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isLoadingCardActive = ref(false);
const map = shallowRef<null | YMap>(null);

const prepareCoordinates = (coordinates: LngLat) => {
  return [coordinates[1], coordinates[0]];
};
const activeCard: Ref<ResultCardType | undefined> = ref(undefined);
const showCard = async (cardUrl: string | undefined) => {
  if (props.showOfferCard && cardUrl) {
    isLoadingCardActive.value = true;
    try {
      const res = await useOfferCardsStore().searchOfferCardByUrl(cardUrl);

      if (res) {
        activeCard.value = res;
      }
    } finally {
      isLoadingCardActive.value = false;
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(YandexMap), {
      modelValue: map.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((map).value = $event)),
      height: _ctx.isFull ? '100vh' : `${_ctx.height === '100%' ? '100%' : `${_ctx.height}px`}`,
      settings: {
        location: {
          center: prepareCoordinates(
            _ctx.centerPointMap ? _ctx.centerPointMap : [47.22208, 39.720353],
          ),
          zoom: _ctx.zoom ? _ctx.zoom : _ctx.centerPointMap ? 12 : 9,
        },
      },
      "cursor-grab": "",
      width: "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(YandexMapDefaultSchemeLayer)),
        _createVNode(_unref(YandexMapDefaultFeaturesLayer)),
        _createVNode(_unref(YandexMapControls), { settings: { position: 'right' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(YandexMapZoomControl))
          ]),
          _: 1
        }),
        _createVNode(_unref(YandexMapControls), { settings: { position: 'left' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(YandexMapGeolocationControl))
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultCardsCoordinates, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createVNode(_unref(YandexMapMarker), {
              settings: { coordinates: prepareCoordinates(item.coordinates) },
              position: "top-center left-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: activeCard.value?.id === item.id }, "pin"]),
                  onClick: ($event: any) => (showCard(item?.customUrl))
                }, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/banner/icon-for-map.svg'),
                    contain: "",
                    name: "map"
                  }, null, 8, ["src"])
                ], 10, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["settings"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "height", "settings"]),
    (isLoadingCardActive.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(LoadingOfferCard))
        ]))
      : (activeCard.value && _ctx.showOfferCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(OfferSmallCard), {
              card: activeCard.value,
              withClose: "",
              onClose: _cache[1] || (_cache[1] = 
          () => {
            activeCard.value = undefined;
          }
        ),
              onMiddle: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToCard)(activeCard.value.landUrl))),
              onChangeActive: _cache[3] || (_cache[3] = ($event: any) => (_unref(goToCard)(activeCard.value.landUrl)))
            }, null, 8, ["card"])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})